// api/staticContent.ts - Static content endpoints

import { AxiosResponse } from 'axios';
import $api from './instance';

// The API returns a raw HTML string, not JSON.

export async function getTermsOfUse(): Promise<AxiosResponse<string>> {
  return $api.get('/static-content/terms-of-use');
}

export async function getPrivacyPolicy(): Promise<AxiosResponse<string>> {
  return $api.get('/static-content/privacy-policy');
}
